import { detectAvifScript, detectWebpScript, getProcessedSrcset, getProcessedUrl, Image, ImageProvider, loadDetectScript } from "../components/ui/image";
export default Image;
export { ImageProvider, detectAvifScript, detectWebpScript, getProcessedSrcset, getProcessedUrl, loadDetectScript };